export enum fundValuationFrequencyFormFields {
  nameEn = 'nameEn',
  nameAr = 'nameAr',
  descriptionEn = 'descriptionEn',
  descriptionAr = 'descriptionAr',
  expression = 'expression',
}
